import React from 'react';
import ReportDrilldownPage from './ReportDrilldownPage';

const FinanceAccountDrilldownReport = () => <ReportDrilldownPage type="finance-account" />;

export default FinanceAccountDrilldownReport;
